module.exports = __webpack_public_path__ + "img/dwg.0672803b.png";